import { useTranslation } from 'react-i18next';
import type { ServerError } from './useReviewRows';

export function ServerErrorList({
  errors,
  onJump,
}: {
  errors: ServerError[];
  onJump: (rowId: number) => void;
}) {
  const { t } = useTranslation('inventory-import');
  if (errors.length === 0) return null;
  return (
    <div className="space-y-2">
      <p className="text-sm font-medium text-error-700">
        {t('review.server_errors_title', { count: errors.length })}
      </p>
      <div className="max-h-48 space-y-2 overflow-y-auto">
        {errors.map((e) => (
          <div
            key={e.rowId}
            className="rounded-lg border border-error-300 bg-error-50 px-3 py-2"
          >
            <button
              type="button"
              onClick={() => onJump(e.rowId)}
              className="mb-1 text-xs font-medium text-error-700 underline hover:opacity-80"
            >
              {t('review.server_error_row', { id: e.rowId })}
            </button>
            <ul className="space-y-0.5">
              {e.messages.map((m) => (
                <li key={`${e.rowId}-${m}`} className="text-xs text-error-600">
                  • {m}
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
}
